import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AttachmentListComponent } from '../../list/attachment-list/attachment-list.component';

@Component({
  selector: 'sn-usc-attachment-lookup',
  templateUrl: './usc-attachment-lookup.component.html',
  styleUrls: ['./usc-attachment-lookup.component.css'],
  host: {
    '[style.display]': '"flex"',
    '[style.flex-direction]': '"column"',
    '[style.overflow]': '"hidden"'    
  }
})
export class UscAttachmentLookupComponent implements OnInit {
  @Input() view:string;
  @Input() data:any;
  @Input() related_type:string;
  @Input() related_ID:number;
  @Input() mode:string;

  constructor(
    public activeModal: NgbActiveModal,
    
  ) { }

  ngOnInit() {
    console.log("UscAttachmentLookupComponent", this.mode);
  }

  selectEvent(event) {
    if (this.mode == "picker") {
      if (event && event.selectedItem) {
        this.activeModal.close(event);
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-attachment-lookup/usc-attachment-lookup.component.ts